import { trackPromise } from 'react-promise-tracker';
import { create } from 'zustand';
import { getNotificationStyle } from '../common/notification';
import { IFileUpload } from '../model/CommonModel';
import {
    IAgreement, IAgreementProduct, IAgreementProductRangeGroupPriceRequest, IAgreementProductStationGroupRequest, IAgreementProductStationRequest, IAgreementProofOfDelivery,
    IAgreementRateRangeListSaveRequest,
    IAgreementRateRangeRequest, IAgreementStationGroupListSaveRequest, IAgreementStationListSaveRequest, ICustomer, ICustomerAddress, ICustomerBillingDetails, ICustomerInitial, ICustomerState,
    IDemurrageAgreementItem,
    IDemurrageAgreementRecord,
    IDuplicateAgreementProduct,
    IEditAgreementProofOfDelivery,
    IIRSReport,
    IOdaPriceRequest,
    ISubAccount, ISubAccountRequestList, ISubmitInvoice, IUpdateAgreementStatus,
    IUpdateCustomerRequest
} from '../model/CustomerModel';
import {
    AddDRERangeRateService,
    AddInternationalRangeService,
    AddProductRangebyProductIdService,
    AddRangeGroupPriceService,
    CreateODAPriceService,
    CreateRangeStationService,
    DeleteAgreementByIdService,
    DeleteAgreementProductByService,
    DeleteAgreementProductStationByIdService,
    DeleteAgreementRangeRateByIdService,
    DeleteCustomerByIdService,
    DeleteFileUploadService,
    DeleteODAPriceService,
    DeletePodTypesByAgreementIdService,
    DeleteRangeGroupPriceService,
    DeleteRangeStationService,
    DeleteStationsGroupByIdService,
    DeleteSubAccountService,
    DownloadCostingSheetFileService,
    DownloadCustomerExcelFileService,
    DownloadFileUploadService,
    DownloadIRSFileService,
    DownloadODAPriceService,
    DownloadPerformaFileService,
    DownloadStationFileService,
    DuplicateAgreementProductService,
    DuplicateAgreementService,
    EditPodTypesForAgreementByIdService,
    ExportODAPriceToExcelService,
    ExportRangeChargesToExcelService,
    ExportStationGroupToExcelService,
    ExportStationToExcelService,
    FileTypeByIdService, GetAgreementBillPeriodService, GetAgreementByIdService, GetAgreementListByIdService, GetAgreementMasterListService,
    GetAgreementProductByIdService, GetAgreementProductListByIdService, GetAgreementRateRangeByIdService,
    GetAgreementRateRangeListByIdService, GetAllPodTypesByAgreementIdService, GetAllPodTypesService, GetCustomerByIdService,
    GetCustomerSubAccountService,
    GetDRERangeRateListService,
    GetInternationalRangeService,
    GetODAPriceService,
    GetProductRangebyProductIdService,
    GetRangeGroupPriceListService,
    GetRangeStationsByIdService,
    GetRangeStationsListByIdService,
    GetStationCityByCountryIdService,
    GetStationCountryService,
    GetStationsByIdService, GetStationsGroupListByIdService, GetStationsListByIdService, GetSubAccountAddressById,
    GetSubAccountAddressListById,
    GetSubAccountBillingAddressById, GetSubAccountBillingAddressListById, GetSubAccountByIdService, GetTrackingByWayBillService, GetUploadedFileListService, GetUploadedIRSFilesService, SaveAgreementProductService,
    SaveAgreementProductStationGroupService, SaveAgreementProductStationService, SaveAgreementRangeRateListService, SaveAgreementRateRangeService, SaveAgreementService, SaveAgreementStationGroupListService, SaveAgreementStationListService, SaveCustomerAddressService,
    SaveCustomerBillingDetailsService, SaveCustomerService, SavePodTypesForAgreementService, SaveSubAccountService, SubmitForInvoiceService,
    UpdateAgreementProductService,
    UpdateAgreementProductStationService, UpdateAgreementRateRangeService, UpdateAgreementService, UpdateAgreementStatusService, UpdateCustomerAddressService,
    UpdateCustomerBillingDetailsService, UpdateCustomerInfoService, UpdateCustomerService, UpdateDRERangeRateService, UpdateRangeGroupPriceService, UpdateRangeStationService, UpdateSubAccountSalesPersonService, UpdateSubAccountService, UploadFilesService, UploadIRSFileService, UploadODAPriceService, UploadRangeStationFileService, UploadStationFileService,
    GetDemurrageMasterService,
    GetDemurrageAgreementService,
    SaveDemurrageAgreementService
} from '../services/customer-service';
import { SessionStorage } from '../services/storage';
import { DE_ACTIVE, DE_ACTIVE_ID, TWO_HUNDRED_SUCCESS_CODE, downloadBlob, downloadURL, fileFormat, removeDuplicateObjects } from '../utils/app-common';
import { convertMillisToDateMoment } from '../utils/luxon';
import { IAgreementProductRequest, IAgreementRequest } from './../model/CustomerModel';
import { messageEnum, responseData } from './common';

const initialValue: ICustomerInitial = {
    customers: {},
    customerDetail: {},
    subAccountAddressList: [],
    subAccountBillingAddressList: [],
    subAccountAddress: {},
    subAccountBillingAddress: {},
    fileTypeList: [],
    agreementList: [],
    agreement: {},
    agreementProductList: [],
    agreementResponse: {},
    agreementProduct: {},
    agreementMasterList: {
        products: undefined,
        subProducts: undefined,
        temperatures: undefined,
        agreementProductUnits: undefined,
        cityGroups: undefined,
        agreementStationGroups: undefined,
        vatTables: undefined,
        statusList: undefined
    },
    agreementProductStation: [],
    agreementProductStationResponse: {},
    agreementProductStationGroup: [],
    agreementProductStationGroupResponse: {},
    agreementRateRangeList: [],
    agreementRateRangeResponse: {},
    agreementRateRangeDetail: {},
    updateRateRangeResponse: {},
    agreementProductStationDetails: {},
    subAccountResponse: undefined,
    stationFileUploadResponse: undefined,
    fileList: [],
    fileDeleteResponseCode: undefined,
    agreementDeleteResponseCode: undefined,
    subAccountRequestList: [],
    saveAgreementPodResponse: undefined,
    deletePodResponse: undefined,
    savePodResponse: undefined,
    editPodResponse: undefined,
    agreementStatusResponse: undefined,
    podTypesList: [],
    podTypesByAgreements: [],
    agreementBillPeriodList: [],
    customerDeleteResponse: undefined,
    updateCustomerResponse: undefined,
    uploadResponse: undefined,
    odaPricesCreateResponse: undefined,
    backToAgreementTab: false,
    irsFiles: [],
    stationCountry: [],
    destinationStationCity: [],
    originStationCity: [],
    agreementTrackingList: [],
    odaPrices: [],
    salesPersonAccountResponse: undefined,
    editAgreementResponse: undefined,
    duplicateAgreementResponse: undefined,
    subAccounts: [],
    range: undefined,
    rangeList: [],
    isRangeTab: false,
    DRERangeList: [],
    rangeGroupPriceList: [],
    demurrageMaster: undefined,
    demurrageAgreementList: []
}

let CustomerStore = create<ICustomerState>((set: any, get: any) => ({
    ...initialValue,
    SaveCustomerAction: async (data: ICustomer) => {
        const response = await SaveCustomerService(data);
        set({ customerDetail: responseData(response?.data) });
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle({ ...response, statusText: messageEnum.CUSTOMER_CREATED_SUCCESSFULLY })
        }
        // get().GetCustomerByIdAction(id)
    },
    SaveCustomerAddressAction: async (data: ICustomerAddress, id: number) => {
        const response = await SaveCustomerAddressService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle({ ...response, statusText: messageEnum.CUSTOMER_ADDRESS_CREATED_SUCCESSFULLY })
        }
        get().GetSubAccountAddressIdAction(id);
        return response
    },
    UpdateCustomerAddressAction: async (data: ICustomerAddress, id: number, subClientId: number) => {
        const response = await UpdateCustomerAddressService(data, id);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle({ ...response, statusText: messageEnum.UPDATE_ADDRESS_SUCCESSFULLY })
        }
        get().GetSubAccountAddressListByIdAction(subClientId);
    },
    SaveCustomerBillingDetailsAction: async (data: ICustomerBillingDetails, id: number) => {
        const response = await SaveCustomerBillingDetailsService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle({ ...response, statusText: messageEnum.CUSTOMER_BILLING_CREATED_SUCCESSFULLY })
        }
        get().GetSubAccountBillingAddressIdAction(id);
        return response
    },
    UpdateCustomerBillingDetailsAction: async (data: ICustomerAddress, id: number, subClientId: number) => {
        const response = await UpdateCustomerBillingDetailsService(data, id);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            get().GetSubAccountBillingAddressIdAction(subClientId);
            getNotificationStyle({ ...response, statusText: messageEnum.UPDATE_BILLING_ADDRESS_SUCCESSFULLY })
        }
    },
    SaveSubAccountAction: async (data: ISubAccount) => {
        const response = await SaveSubAccountService(data);
        const { statusCode } = response?.data || {};
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            set({ subAccountResponse: statusCode });
            getNotificationStyle({ ...response, statusText: messageEnum.ACCOUNT_CREATED_SUCCESSFULLY })
            trackPromise(get().GetCustomerSubAccountAction(data?.clientId), 'customer-sub-account-area');
        }
        trackPromise(get().GetCustomerByIdAction(data.clientId), 'account-list-area');
    },
    GetCustomerByIdAction: async (id: number | undefined) => {
        const response = await GetCustomerByIdService(id);
        SessionStorage.setObject('customerDetail', responseData(response?.data))
        set({ customerDetail: responseData(response?.data) });
    },
    GetSubAccountAddressIdAction: async (id: number) => {
        const response = await GetSubAccountAddressById(id);
        set({ subAccountAddress: responseData(response?.data) });
    },
    GetSubAccountBillingAddressIdAction: async (id: number) => {
        const response = await GetSubAccountBillingAddressById(id);
        set({ subAccountBillingAddress: responseData(response?.data) });
    },
    GetSubAccountAddressListByIdAction: async (id: number) => {
        const response = await GetSubAccountAddressListById(id);
        set({ subAccountAddressList: responseData(response?.data) });
    },
    GetSubAccountBillingAddressListByIdAction: async (id: number) => {
        const response = await GetSubAccountBillingAddressListById(id);
        set({ subAccountBillingAddressList: responseData(response?.data) });
    },
    UpdateCustomerAction: async (id: number, data: ICustomer) => {
        const response = await UpdateCustomerService(id, data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            set({ customerDetail: responseData(response?.data) });
            getNotificationStyle({ ...response, statusText: messageEnum.CUSTOMER_CREATED_SUCCESSFULLY })
        }
        trackPromise(get().GetCustomerByIdAction(id), 'account-list-area');
    },
    DeleteCustomerByIdAction: async (id: number) => {
        const response = await DeleteCustomerByIdService(id);
        // set({ customers: responseData(response?.data) });
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            set({ customerDeleteResponse: response.status })
            getNotificationStyle({ ...response, statusText: messageEnum.CUSTOMER_DELETED });
            trackPromise(get().GetCustomerListAction(100, 1), 'customer-list-area');
        }
    },
    FileTypeByIdAction: async (id: number) => {
        const response = await FileTypeByIdService(id);
        set({ fileTypeList: responseData(response?.data) });
    },
    GetAgreementListByIdAction: async (id: number | undefined) => {
        set({ agreementList: [] });
        const response = await GetAgreementListByIdService(id);
        const agreementArray: IAgreement[] = responseData(response?.data)?.map((item: IAgreement) => ({
            ...item,
            startDate: convertMillisToDateMoment(item?.startDate),
            endDate: convertMillisToDateMoment(item?.endDate),
            // convertedStartDate: convertDateFromMillis(item?.startDate),
            // convertedEndDate: convertDateFromMillis(item?.endDate)
        }));

        set({ agreementList: agreementArray });
    },
    UpdateAgreementStatusAction: async (data: IUpdateAgreementStatus, agreementId: number, productId: number) => {
        const response = await UpdateAgreementStatusService(data, agreementId);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            set({ agreementStatusResponse: response?.status })
            getNotificationStyle({ ...response });
            trackPromise(
                get().GetAgreementListByIdAction(productId),
                'agreement-list-area'
            )
        };
    },
    SaveAgreementAction: async (data: IAgreementRequest, id: number) => {
        const response = await SaveAgreementService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            set({ agreementResponse: (response) });
            getNotificationStyle({ ...response });
            trackPromise(
                get().GetAgreementListByIdAction(id),
                'agreement-list-area'
            )
        }
    },
    DuplicateAgreementAction: async (data: IAgreementRequest, id: number, agreementId?: number) => {
        const response = await DuplicateAgreementService(data, agreementId);
        const { status } = response || {};
        if (status === TWO_HUNDRED_SUCCESS_CODE) {
            set({ duplicateAgreementResponse: status });
            getNotificationStyle({ ...response });
            trackPromise(get().GetAgreementListByIdAction(id), 'agreement-list-area')
        }
    },
    GetAgreementByIdAction: async (id: number | undefined) => {
        const response = await GetAgreementByIdService(id!);
        const result = responseData(response?.data);
        const manipulatedAgreement: IAgreement = {
            ...result,
            startDate: convertMillisToDateMoment(result?.startDate),
            endDate: convertMillisToDateMoment(result?.endDate)
        };
        set({ agreement: manipulatedAgreement });
    },
    GetAgreementProductListByIdAction: async (id: number | undefined) => {
        const response = await GetAgreementProductListByIdService(id!);
        set({ agreementProductList: responseData(response?.data) });
    },
    GetAgreementProductByIdAction: async (id: number | undefined) => {
        const response = await GetAgreementProductByIdService(id!);
        set({ agreementProduct: responseData(response?.data) });
    },
    SaveAgreementProductAction: async (data: IAgreementProductRequest, agreementId: number) => {
        const response = await SaveAgreementProductService(data);
        set({ agreementResponse: response });
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle({ ...response })
        };
        trackPromise(get().GetAgreementProductListByIdAction(agreementId), 'agreement-product-area');
    },
    DeleteAgreementProductByIdAction: async (id: number | undefined, agreementId: number) => {
        const response = await DeleteAgreementProductByService(id!);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle({ ...response });
        };
        trackPromise(get().GetAgreementProductListByIdAction(agreementId), 'agreement-product-area');
    },
    GetAgreementMasterListAction: async () => {
        const response = await GetAgreementMasterListService();
        const result = responseData(response?.data);
        SessionStorage.set('productAgreementMasterList', JSON.stringify(result));
        set({ agreementMasterList: result });
    },
    GetStationsListByIdAction: async (id: number) => {

        const response = await GetStationsListByIdService(id!, get().range);
        const result = responseData(response?.data);
        set({ agreementProductStation: result })
    },
    DeleteAgreementProductStationByIdAction: async (id: number | undefined, productId: number) => {
        const response = await DeleteAgreementProductStationByIdService(id!);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle({ ...response });
        };
        get().GetStationsListByIdAction(productId);
    },
    SaveAgreementStationAction: async (data: IAgreementProductStationRequest, productId: number | undefined) => {
        const response = await SaveAgreementProductStationService(data);
        set({ agreementProductStationResponse: response });
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle({ ...response })
        };
        get().GetStationsListByIdAction(productId);
    },
    UpdateAgreementStationAction: async (data: IAgreementProductStationRequest, productId: number | undefined, rowId: number) => {
        const response = await UpdateAgreementProductStationService(data, rowId);
        set({ agreementProductStationResponse: response });
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle({ ...response })
        };
        get().GetStationsListByIdAction(productId);
    },
    GetStationsGroupListByIdAction: async (id: number | undefined) => {
        const response = await GetStationsGroupListByIdService(id!);
        const result = responseData(response?.data);
        set({ agreementProductStationGroup: result })
    },
    SaveAgreementStationGroupAction: async (data: IAgreementProductStationGroupRequest, productId: number | undefined) => {
        const response = await SaveAgreementProductStationGroupService(data);
        set({ agreementProductStationGroupResponse: response });
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle({ ...response })
        };
        get().GetStationsGroupListByIdAction(productId);
    },
    DeleteStationsGroupByIdAction: async (id: number | undefined, productId: number) => {
        const response = await DeleteStationsGroupByIdService(id!);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle({ ...response });
        };
        get().GetStationsGroupListByIdAction(productId);
    },
    GetAgreementRateRangeListByIdAction: async (id: number | undefined) => {
        const response = await GetAgreementRateRangeListByIdService(id!);
        const result = responseData(response?.data);
        set({ agreementRateRangeList: result })
    },
    GetAgreementRateRangeByIdAction: async (id: number | undefined) => {
        const response = await GetAgreementRateRangeByIdService(id!);
        const result = responseData(response?.data);
        set({ agreementRateRangeDetail: result })
    },
    SaveAgreementRateRangeAction: async (data: IAgreementRateRangeRequest, productId: number | undefined) => {
        const response = await SaveAgreementRateRangeService(data);
        set({ agreementRateRangeResponse: response });
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle({ ...response })
        };
        get().GetAgreementRateRangeListByIdAction(productId);
    },
    UpdateAgreementRateRangeAction: async (data: IAgreementRateRangeRequest, productId: number | undefined, id: number) => {
        const response = await UpdateAgreementRateRangeService(data, id);
        set({ updateRateRangeResponse: response });
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle({ ...response })
        };
        get().GetAgreementRateRangeListByIdAction(productId);
    },
    DeleteAgreementRateRangeByIdAction: async (id: number | undefined, productId: number) => {
        const response = await DeleteAgreementRangeRateByIdService(id!);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle({ ...response });
        };
        get().GetAgreementRateRangeListByIdAction(productId);
    },
    GetStationsByIdAction: async (id: number | undefined) => {
        const response = await GetStationsByIdService(id);
        set({ agreementProductStationDetails: responseData(response?.data) })
    },
    DownloadStationFileAction: async (id: number | undefined) => {
        const response = await DownloadStationFileService(id, get().isRangeTab);
        const { fileName, fileType, file } = responseData(response?.data);
        downloadBlob(file, fileName, fileFormat[fileType]);
    },
    UploadStationFileAction: async (file: any, id: number | undefined, range: number | undefined) => {
        const response = await UploadStationFileService(file, id, range);
        const { statusCode } = response?.data || {};
        set({ stationFileUploadResponse: statusCode });
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            trackPromise(get().GetStationsListByIdAction(id), 'station-list-area');
        }
    },
    GetUploadedFileListAction: async (subClientId: number | undefined) => {
        const response = await GetUploadedFileListService(subClientId!);
        set({ fileList: responseData(response?.data) })
    },
    UploadFilesAction: async (fileObject: Partial<IFileUpload>) => {
        const response = await UploadFilesService(fileObject);
        const { clientSubId } = responseData(response?.data)
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
            trackPromise(get().GetUploadedFileListAction(clientSubId), 'file-upload-area')
        }
    },
    //  DownloadFileUploadAction: (id: number) => Promise<any>
    // DeleteFileUploadAction: (id: number) => Promise<any>
    DownloadFileUploadAction: async (id: number | undefined) => {
        const response = await DownloadFileUploadService(id);
        const { filePath, fileContent, fileStr } = responseData(response?.data);
        downloadBlob(fileStr, filePath, fileContent);
    },
    DeleteFileUploadAction: async (id: number | undefined, subAccountId: number | undefined) => {
        const response = await DeleteFileUploadService(id);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            set({ fileDeleteResponseCode: (statusCode) })
            trackPromise(get().GetUploadedFileListAction(subAccountId), 'file-upload-area')
            getNotificationStyle({ ...response })
        };
    },
    DeleteAgreementByIdAction: async (agreementId: number | undefined, productId: number | undefined) => {
        const response = await DeleteAgreementByIdService(agreementId);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            set({ agreementDeleteResponseCode: (statusCode), agreementList: [] })
            getNotificationStyle({ ...response });
            trackPromise(
                get().GetAgreementListByIdAction(productId),
                'agreement-list-area'
            )
        };
    },
    DownloadCustomerExcelFileAction: async () => {
        const response = await DownloadCustomerExcelFileService();
        const { fileName, fileType, file } = responseData(response?.data);
        downloadBlob(file, fileName, fileFormat[fileType]);
    },
    ExportStationToExcelAction: async (productId: number | undefined,) => {
        const response = await ExportStationToExcelService(productId);
        const { fileName, file } = responseData(response?.data);
        downloadBlob(file, fileName, fileFormat["excel"]);
    },
    ExportStationGroupToExcelAction: async (productId: number | undefined) => {
        const response = await ExportStationGroupToExcelService(productId);
        const { fileName, file } = responseData(response?.data);
        downloadBlob(file, fileName, fileFormat["excel"]);
    },
    ExportRangeChargesToExcelAction: async (productId: number | undefined) => {
        const response = await ExportRangeChargesToExcelService(productId);
        const { fileName, file } = responseData(response?.data);
        downloadBlob(file, fileName, fileFormat["excel"]);
    },
    SubmitForInvoiceAction: async (request: ISubmitInvoice) => {
        const response = await SubmitForInvoiceService(request);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle({ ...response });
        };
    },
    GetAllPodTypesAction: async (id: number) => {
        const response = await GetAllPodTypesService(id);
        set({ podTypesList: responseData(response?.data) })

    },
    GetAllPodTypesByAgreementIdAction: async (id: number) => {
        const response = await GetAllPodTypesByAgreementIdService(id);
        set({ podTypesByAgreements: responseData(response?.data) })
    },
    DeletePodTypesByAgreementIdAction: async (id: number, agreementId: number) => {
        const response = await DeletePodTypesByAgreementIdService(id);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle({ ...response });
            trackPromise(get().GetAllPodTypesByAgreementIdAction(agreementId), 'all-pod-types-area')
            trackPromise(get().GetAllPodTypesAction(agreementId), 'all-pod-types-area')
            set({ deletePodResponse: statusCode })
        };
    },
    SavePodTypesForAgreementAction: async (request: IAgreementProofOfDelivery, agreementId: number) => {
        const response = await SavePodTypesForAgreementService(request);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            set({ savePodResponse: statusCode })
            trackPromise(get().GetAllPodTypesByAgreementIdAction(agreementId), 'all-agreement-pod-types-area')
            trackPromise(get().GetAllPodTypesAction(agreementId), 'all-pod-types-area')
            getNotificationStyle({ ...response });
        };
    },
    EditPodTypesForAgreementByIdAction: async (request: IEditAgreementProofOfDelivery, agreementId: number) => {
        const response = await EditPodTypesForAgreementByIdService(request);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            set({ editPodResponse: statusCode })
            trackPromise(get().GetAllPodTypesByAgreementIdAction(agreementId), 'all-agreement-pod-types-area')
            trackPromise(get().GetAllPodTypesAction(agreementId), 'all-pod-types-area')
            getNotificationStyle({ ...response });
        };
    },
    GetAgreementBillPeriodAction: async () => {
        const response = await GetAgreementBillPeriodService();
        set({ agreementBillPeriodList: responseData(response?.data) });
    },
    GetSubAccountByIdAction: async (id?: number | undefined) => {
        const response = await GetSubAccountByIdService(id);
        set({ subAccountRequestList: responseData(response?.data) });
    },
    UpdateSubAccountAction: async (data: ISubAccountRequestList, id: number | undefined) => {
        const response = await UpdateSubAccountService(data, id);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            set({ subAccountResponse: response?.data });
            getNotificationStyle({ ...response, statusText: messageEnum.ACCOUNT_CREATED_SUCCESSFULLY })
            trackPromise(get().GetCustomerSubAccountAction(data?.clientId), 'customer-sub-account-area');
            trackPromise(get().GetCustomerByIdAction(data?.clientId), 'account-list-area');
        }
    },
    UpdateSubAccountSalesPersonAction: async (data: Partial<ISubAccountRequestList>, id?: number, clientId?: number) => {
        const response = await UpdateSubAccountSalesPersonService(data, id);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            set({ salesPersonAccountResponse: statusCode });
            getNotificationStyle({ ...response, statusText: messageEnum.ACCOUNT_CREATED_SUCCESSFULLY })
            trackPromise(get().GetCustomerSubAccountAction(clientId), 'customer-sub-account-area');
        }
    },
    GetCustomerSubAccountAction: async (customerId?: number) => {
        set({ subAccounts: [] });
        const response = await GetCustomerSubAccountService(customerId);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            set({
                subAccounts: responseData(response?.data)
                    ?.filter((item: ISubAccount) =>
                        !((item?.status === DE_ACTIVE) ||
                            (item?.statusId === DE_ACTIVE_ID)))
                    ?.map((item: ISubAccount) => ({
                        ...item,
                        blockedText: item?.isBlocked ? 'Blocked' : 'Not Blocked',
                    }))
            })
        }
    },
    DeleteSubAccountAction: async (customerId?: number, clientId?: number) => {
        const response = await DeleteSubAccountService(customerId);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            set({ subAccounts: [] });
            trackPromise(get().GetCustomerSubAccountAction(clientId), 'customer-sub-account-area');
        }
    },
    UpdateAgreementAction: async (id?: number | undefined, data?: IAgreementRequest) => {
        const response = await UpdateAgreementService(id, data);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            set({ editAgreementResponse: statusCode })
            trackPromise(get().GetAgreementByIdAction(id), 'agreement-details')
            getNotificationStyle(response);
        }
    },
    UpdateAgreementProductAction: async (id: number | undefined, data?: IAgreementProduct) => {
        const response = await UpdateAgreementProductService(id, data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE && response?.data?.statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            get()?.GetAgreementProductByIdAction(id)
        }
        return response;
    },
    DuplicateAgreementProductAction: async (data: IDuplicateAgreementProduct, agreementId: number) => {
        const response = await DuplicateAgreementProductService(data);
        set({ agreementResponse: (response) });
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle({ ...response });
            trackPromise(get().GetAgreementProductListByIdAction(agreementId), 'agreement-product-area');
        }
    },
    SaveAgreementStationListAction: async (data: IAgreementStationListSaveRequest, productId: number | undefined) => {
        const response = await SaveAgreementStationListService(data, productId);
        set({ agreementProductStationResponse: response });
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle({ ...response })
            trackPromise(get().GetStationsListByIdAction(productId), 'station-list-area')
        };
    },
    DownloadIRSFileAction: async (quoteNo: number | undefined) => {
        const response = await DownloadIRSFileService(quoteNo);
        const data = responseData(response?.data);
        trackPromise(downloadBlob((data), `${quoteNo}.pdf`), 'download-file-area');
    },
    GetUploadedIRSFileListAction: async (subClientId: number | undefined) => {
        const response = await GetUploadedIRSFilesService(subClientId!);
        set({ irsFiles: responseData(response?.data) })
    },
    UploadIRSFileAction: async (fileObject: Partial<IFileUpload>, clientSubId: number) => {
        const response = await UploadIRSFileService(fileObject);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
            trackPromise(get().GetUploadedIRSFileListAction(clientSubId), 'irs-files-area')
        }
    },
    SaveAgreementStationGroupListAction: async (data: IAgreementStationGroupListSaveRequest, productId: number | undefined) => {
        const response = await SaveAgreementStationGroupListService(data, productId);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            set({ agreementProductStationResponse: response });
            getNotificationStyle({ ...response })
            trackPromise(get().GetStationsGroupListByIdAction(productId), 'station-group-list-area')
        };
    },
    SaveAgreementRangeRateListAction: async (data: IAgreementRateRangeListSaveRequest, productId: number | undefined) => {
        const response = await SaveAgreementRangeRateListService(data, productId);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            set({ agreementProductStationResponse: response });
            getNotificationStyle({ ...response })
            trackPromise(get().GetAgreementRateRangeListByIdAction(productId), 'range-range-list-area')
        };
    },
    GetStationCountryAction: async () => {
        const response = await GetStationCountryService();
        set({ stationCountry: removeDuplicateObjects(responseData(response?.data), 'id') })
    },
    GetStationCityByCountryIdAction: async (countryId: number | undefined, name: ('origin' | 'destination')) => {
        const response = await GetStationCityByCountryIdService(countryId);
        name === 'origin' && set({ originStationCity: removeDuplicateObjects(responseData(response?.data), 'id') })
        name === 'destination' && set({ destinationStationCity: removeDuplicateObjects(responseData(response?.data), 'id') })
    },
    GetTrackingByWayBillAction: async (wayBill: string) => {
        const response: any = await GetTrackingByWayBillService(wayBill);
        set({ agreementTrackingList: responseData(response?.data) })
    },
    UpdateCustomerInfoAction: async (request: Partial<IUpdateCustomerRequest>, customerId: number) => {
        const response: any = await UpdateCustomerInfoService(request, customerId);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle({ ...response });
            set({ updateCustomerResponse: response?.status });
        };
    },
    GetODAPriceAction: async (agreementProductId: number) => {
        set({ odaPrices: [] });
        const response: any = await GetODAPriceService(agreementProductId, get().range);
        set({ odaPrices: responseData(response?.data) })
    },
    UploadODAPriceAction: async (fileObject: Partial<IFileUpload>, agreementProductId: number, range: number) => {
        const response: any = await UploadODAPriceService(fileObject, agreementProductId, range);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle({ ...response });
            set({ uploadResponse: statusCode })
            trackPromise(get().GetODAPriceAction(agreementProductId), 'get-oda-price-area')
        };
    },
    DownloadODAPriceAction: async (agreementProductId: number) => {
        const response: any = await DownloadODAPriceService(agreementProductId);
        const { fileName, file, fileType } = responseData(response?.data);
        trackPromise(downloadBlob((file), `${fileName}.${fileType}`), 'download-file-area');
    },
    DeleteODAPriceAction: async (id: number, agreementProductId: number) => {
        const response: any = await DeleteODAPriceService(id);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle({ ...response });
            trackPromise(get().GetODAPriceAction(agreementProductId), 'get-oda-price-area')
        };
    },
    CreateODAPriceAction: async (request: Partial<IOdaPriceRequest>, agreementProductId: number) => {
        const response: any = await CreateODAPriceService(request);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle({ ...response });
            set({ odaPricesCreateResponse: responseData(response?.data) })
            trackPromise(get().GetODAPriceAction(agreementProductId), 'get-oda-price-area')
        };
    },
    ExportODAPriceToExcelAction: async (agreementProductId: number) => {
        const response: any = await ExportODAPriceToExcelService(agreementProductId);
        const { fileName, file, fileType } = responseData(response?.data);
        trackPromise(downloadBlob((file), `${fileName}.${fileType}`), 'download-file-area');
    },
    DownloadPerformaFileAction: async ({ enquiryQuotationId, manifestId }: IIRSReport) => {
        const response: any = await DownloadPerformaFileService({ enquiryQuotationId, manifestId });
        const { statusCode, data } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            trackPromise(downloadURL(data?.response), 'download-performa-file-area');
        }
    },
    DownloadCostingSheetFileAction: async ({ enquiryQuotationId, manifestId }: IIRSReport) => {
        const response: any = await DownloadCostingSheetFileService({ enquiryQuotationId, manifestId });
        const { statusCode, data } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            trackPromise(downloadURL(data?.response), 'download-costing-file-area');
        }
    },
    GetProductRangebyProductIdAction: async (id: number) => {
        const response = await GetProductRangebyProductIdService(id);
        set({ rangeList: responseData(response?.data) });
    },
    PostProductRangebyProductIdAction: async (payload, ProductId) => {
        const response = await trackPromise(AddProductRangebyProductIdService(payload), 'post-range-area');
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            trackPromise(get().GetProductRangebyProductIdAction(ProductId), 'post-range-area');
        }
        return response?.status
    },
    GetInternationalRangeAction: async (id: number) => {
        const response = await GetInternationalRangeService(id);
        set({ rangeList: responseData(response?.data) });
    },
    PostInternationalRangeByProductIdAction: async (payload, ProductId) => {
        const response = await trackPromise(AddInternationalRangeService(payload, ProductId), 'post-range-area');
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            trackPromise(get().GetInternationalRangeAction(ProductId), 'post-range-area');
        }
        return response?.status
    },
    GetRangeStationsListByIdAction: async (rangeID: number) => {
        const response = await GetRangeStationsListByIdService(rangeID);
        const result = responseData(response?.data);
        set({ agreementProductStation: result })
    },
    CreateRangeStationsListByIdAction: async (req, rangeID: number) => {
        const response = await CreateRangeStationService(req, rangeID);
        set({ agreementProductStationResponse: response });
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle({ ...response })
            trackPromise(get().GetRangeStationsListByIdAction(rangeID), 'station-list-area')
        };
    },
    UpdateRangeStationsListByIdAction: async (req, rangeID: number) => {
        const response = await UpdateRangeStationService(req);
        set({ agreementProductStationResponse: response });
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle({ ...response })
            trackPromise(get().GetRangeStationsListByIdAction(rangeID), 'station-list-area')
        };
    },
    DeleteRangeStationByIdAction: async (id: number | undefined) => {
        const response = await DeleteRangeStationService(id!);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle({ ...response });
            set({ agreementProductStation: get().agreementProductStation?.filter((item) => item?.id !== id) })
        };

    },
    GetRangeStationsByIdAction: async (id: number | undefined) => {
        const response = await GetRangeStationsByIdService(id);
        set({ agreementProductStationDetails: responseData(response?.data) })
    },
    UploadRangeStationFileAction: async (file: any, id: number | undefined, range: number | undefined) => {
        const response = await UploadRangeStationFileService(file, id, range);
        const { statusCode } = response?.data || {};
        set({ stationFileUploadResponse: statusCode });
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            trackPromise(get().GetRangeStationsListByIdAction(range), 'station-list-area')
        }
    },
    AddDRERangeRateAction: async (req) => {
        const response = await trackPromise(AddDRERangeRateService(req), 'add-dre-range-rate-area');
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            get()?.GetDRERangeRateListAction(req?.agreementProductRangeId)
            getNotificationStyle({ ...response })

        };
        return response;
    },
    UpdateDRERangeRateAction: async (req) => {
        const response = await trackPromise(UpdateDRERangeRateService(req), 'update-dre-range-rate-area');
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            get()?.GetDRERangeRateListAction(req?.agreementProductRangeId)
            getNotificationStyle({ ...response })

        };
        return response;
    },
    GetDRERangeRateListAction: async (RangeId) => {
        const response = await trackPromise(GetDRERangeRateListService(RangeId), 'get-dre-range-rate-area');
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            set({ DRERangeList: responseData(response?.data) })

        };
        return response;
    },
    AddRangeGroupPriceAction: async (req: IAgreementProductRangeGroupPriceRequest) => {
        const response = await trackPromise(AddRangeGroupPriceService(req), 'add-range-group-price-area');
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            get()?.GetRangeGroupPriceListAction(req?.agreementProductRangesId)
            getNotificationStyle({ ...response })
        };
        return response;
    },
    UpdateRangeGroupPriceAction: async (req: IAgreementProductRangeGroupPriceRequest) => {
        const response = await trackPromise(UpdateRangeGroupPriceService(req), 'update-range-group-price-area');
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            get()?.GetRangeGroupPriceListAction(req?.agreementProductRangesId)
            getNotificationStyle({ ...response })
        };
        return response;
    },
    GetRangeGroupPriceListAction: async (rangeId: number) => {
        const response = await trackPromise(GetRangeGroupPriceListService(rangeId), 'get-range-group-price-area');
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            set({ rangeGroupPriceList: responseData(response?.data) })
        };
        return response;
    },
    DeleteRangeGroupPriceByIdAction: async (id: number, rangeId: number) => {
        const response = await trackPromise(DeleteRangeGroupPriceService(id), 'delete-range-group-price-area');
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle({ ...response });
            get()?.GetRangeGroupPriceListAction(rangeId)
        };
        return response;
    },
    GetDemurrageMasterAction: async () => {
        const cached = SessionStorage.get('demurrageMaster');
        if (cached) {
            set({ demurrageMaster: JSON.parse(cached) });
            return;
        }
        const response = await GetDemurrageMasterService();
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const result = responseData(response?.data);
            SessionStorage.set('demurrageMaster', JSON.stringify(result));
            set({ demurrageMaster: result });
        }
    },
    GetDemurrageAgreementAction: async (agreementId: number) => {
        set({ demurrageAgreementList: [] });
        const response = await GetDemurrageAgreementService(agreementId);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const result: IDemurrageAgreementRecord[] = responseData(response?.data) ?? [];
            set({ demurrageAgreementList: result });
        }
    },
    SaveDemurrageAgreementAction: async (data: IDemurrageAgreementItem[]) => {
        const response = await SaveDemurrageAgreementService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle({ ...response, statusText: messageEnum.DEMURRAGE_SAVED_SUCCESSFULLY });
        }
    },
    ClearStore: () => {
        set(initialValue)
    }
}))


export const useCustomerStore = (CustomerStore)